export default __webpack_public_path__ + "static/media/Img431.614b95b7.jpg";